module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/1/1-1e0f740c83d045ff070d1a746924e5e4.jpg";